import { makeObservable, observable, computed, action } from 'mobx';
import { erpApiurl } from '../stores/APIEndpoints';


const PENDING = 'pending';
const DONE = 'done';
const ERROR = 'error';

const EMPTY_MESSAGE = { status: "", help: "" };
const ERROR_MESSAGE = { status: "error", help: "Unable to fetch the Invoices. The Service is unavailable. Please try after sometime." };

export default class InvoiceSummaryStore {

    state = PENDING;
    message = EMPTY_MESSAGE;
    invoices = [];
    rowCount = 0;

    constructor(props) {
        this.apiProxy = props.apiProxy;
        this.collectionType = props.collectionType;

        makeObservable(this, {
            state: observable,
            message: observable,
            invoices: observable,
            rowCount: observable,

            isLoading: computed,
            isError: computed,
            isDone: computed,

            fetchInvoices: action,
        });
    }


    get isLoading() {
        return this.state === PENDING;
    }

    get isError() {
        return this.state === ERROR;
    }

    get isDone() {
        return this.state === DONE;
    }

   
    /**
     * Send the request to the endpoint using the FetchAPI
     * 
     */
     fetchInvoices = async () => {
        const url = `${erpApiurl}api/Carbon/GetLabBillSummary?collectionType=${this.collectionType}&Paidstatus=1`
        this.state = PENDING;
        this.message = EMPTY_MESSAGE;

        try {
            const response = await this.apiProxy.getAsync(url);
            const data = await response.json();

            if (data.Message) {
                this.message = ERROR_MESSAGE;
                this.state = DONE;
                return;
            }
            this.invoices = data;
            this.rowCount = data.length;
            this.state = DONE;
            
        }
        catch (e) {
            this.state = ERROR;
            this.message = ERROR_MESSAGE
            console.log(e);
        }
    }
}
